import L from 'leaflet';

const key = {};

export { L, key };
